import { UsersImportFileUpload } from '@/components/users/UsersImportFileUpload';
import { UsersImportModal } from '@/components/users/UsersImportModal';
import React, { useCallback, useMemo, useState } from 'react';

const noop = () => undefined;

type UsersImportFlowOptions = {
  branchId?: string;
  groupId?: string;
  refetch?: () => void;
};

type UsersImportUploadOptions = {
  className: 'button' | 'file-upload';
  chooseLabel: string;
  chooseIcon?: React.ReactNode;
  resetDialogData?: () => void;
  onDoNotShowAgain?: () => void;
};

export const useUsersImportFlow = ({
  branchId,
  groupId,
  refetch = noop,
}: UsersImportFlowOptions) => {
  const [fileId, setFileId] = useState<string | null>(null);
  const [isUploading, setIsUploading] = useState(false);

  const renderFileUpload = useCallback(
    ({
      className,
      chooseLabel,
      chooseIcon,
      resetDialogData,
      onDoNotShowAgain,
    }: UsersImportUploadOptions) => (
      <UsersImportFileUpload
        className={className}
        chooseLabel={chooseLabel}
        chooseIcon={chooseIcon}
        isUploading={isUploading}
        onUploaded={(id) => setFileId(id)}
        resetDialogData={resetDialogData}
        onDoNotShowAgain={onDoNotShowAgain}
      />
    ),
    [isUploading],
  );

  const importModal = useMemo(
    () => (
      <UsersImportModal
        setIsUploading={setIsUploading}
        isUploading={isUploading}
        fileId={fileId}
        visible={!!fileId}
        onHide={() => setFileId(null)}
        branchId={branchId}
        groupId={groupId}
        refetch={refetch}
      />
    ),
    [branchId, groupId, fileId, isUploading, refetch],
  );

  return {
    fileId,
    isUploading,
    renderFileUpload,
    importModal,
  };
};
